import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
const Status_Component = (props) => {
  return (
    <div>
      <Flex
        borderRadius={20}
        bg={props.bg}
        py={2}
        px={4}
        w="fit-content"
        justify="center"
        align="center"
      >
        <Text fontSize={14} fontFamily={"Roboto"}>
          {props.action}
        </Text>
      </Flex>
    </div>
  );
};
export default Status_Component;
